// JsFromRoutes CacheKey b9c64a9ea7e6f02fefacdbe46fa41616
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delete: /* #__PURE__ */ definePathHelper('get', '/accounts/:public_id/delete'),
  preview: /* #__PURE__ */ definePathHelper('post', '/accounts/:public_id/preview'),
  archive: /* #__PURE__ */ definePathHelper('patch', '/accounts/:public_id/archive'),
  restore: /* #__PURE__ */ definePathHelper('patch', '/accounts/:public_id/restore'),
  index: /* #__PURE__ */ definePathHelper('get', '/accounts'),
  create: /* #__PURE__ */ definePathHelper('post', '/accounts'),
  new: /* #__PURE__ */ definePathHelper('get', '/accounts/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/accounts/:public_id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/accounts/:public_id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/accounts/:public_id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/accounts/:public_id'),
}
